import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  Divider,
  CircularProgress,
} from "@mui/material";
import { CloseSharp as CloseIcon } from "@mui/icons-material";
import Toast from "./toast";
import { uploadDocument } from "../helpers/UserChats";

const ReportUpload = ({ open, handleClose, handleUploadReport, chatId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [File, setFile] = useState(null);

  //-------Upload File-------------
  const convertBase64 = (file, cb) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result.replace("data:", "").replace(/^.+,/, ""));
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  };

  const handleUploadFiles = (files, previewUrl) => {
    if (files.length === 1) {
      files.map(async (file) => {
        const fileSize = files[0].size;

        // Updated allowed types list
        const allowedTypes = [
          "application/pdf",
          "image/png",
          "image/jpeg",
          "image/jpg",
          "image/webp", // Added WebP
          "application/msword", // Added .doc
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // Added .docx
        ];

        if (fileSize > 3 * 1048576) {
          setFile(null);
          alert(`Maximum file size is 3 Mb.`);
          return;
        } else if (allowedTypes.includes(file.type)) {
          await convertBase64(file, (result) => {
            const newItem = {
              Name: file.name,
              fileType: file.type,
              File: result,
              previewUrl: previewUrl,
            };
            // dispatch(setFiles(newItem, branch));
            setFile(newItem);
          });
        } else {
          setFile(null);
          alert(`Only Images and Pdfs are allowed.`);
        }
      });
    }
  };

  const handleFileChange = (e) => {
    const chosenFiles = Array.prototype.slice.call(e.target.files);
    // dispatch(setFiles(null, branch));
    const file = e.target.files[0];
    const reader = new FileReader();
    let previewUrl;
    reader.onload = () => {
      previewUrl = reader.result;
      setFile(null);
      handleUploadFiles(chosenFiles, previewUrl);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  //-------------------

  const handleSave = async () => {
    if (File === null) {
      Toast.error("Select a file to save!");
      return;
    }

    // Logic to upload file
    try {
      setIsLoading(true);
      const payload = {
        chatID: chatId,
        File: File,
      };

      const response = await uploadDocument(payload);
      setIsLoading(false);
      if (response.statusCode === 200 && response.isSuccess === true) {
        Toast.success(response.message);
        handleUploadReport(true);
      } else {
        Toast.error(response.message);
      }
    } catch (error) {
      Toast.error(error.message);
      setIsLoading(false);
    }
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "400px",
    bgcolor: "#f0f0f0",
    border: "2px solid #fff",
    borderRadius: "12px",
    // boxShadow: 24,
    p: "5px 10px",
    maxHeight: "80vh", // set max height
    overflow: "auto", // enable scrolling
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {/* <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography>Upload Your Report</Typography>
          <CloseIcon sx={{ mx: 1, fontSize: 36 }} />
        </div>
        <Divider />
        <Typography>TESTING</Typography> */}
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography fontSize={20} fontWeight={600}>
            Upload Your Report
          </Typography>

          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider />

        <Typography mt={3} mb={1.5} fontSize={14} fontWeight={500}>
          Attach Your Reports
        </Typography>

        {/* File Upload */}
        <Box position="relative">
          <input
            type="file"
            id="fileInput"
            style={{ display: "none" }}
            onChange={handleFileChange}
            // accept=".jpg, .jpeg, .png, .pdf"
            accept="image/jpeg,image/png,image/webp,application/pdf,.doc,.docx"
          />
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "12px",
              border: "1px solid #8E85F7",
            }}
          >
            <Button
              variant="contained"
              sx={{
                width: "50%",
                bgcolor: "#7B7DE5",
                textTransform: "none",
                borderRadius: "8px",
                "&:hover": { bgcolor: "#8E85F7" },
              }}
              onClick={() => document.getElementById("fileInput").click()}
            >
              Browse Your Document
            </Button>
            <Typography
              sx={{
                width: "50%",
                textAlign: "center",
                color: "#A29BFE",
              }}
            >
              {File !== null && File.Name
                ? File.Name.substring(0, 20)
                : "Select your file"}
            </Typography>
          </div>
        </Box>

        {/* Save Button */}
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <Button
            fullWidth
            sx={{
              my: 2,
              width: "120px",
              bgcolor: "#7B7DE5",
              color: "#fff",
              textTransform: "none",
              //   py: 1,
              borderRadius: "10px",
              "&:hover": { bgcolor: "#8E85F7" },
            }}
            onClick={handleSave}
          >
            {isLoading === true ? (
              <CircularProgress color="#fff" size={"24px"} />
            ) : (
              "Save"
            )}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default ReportUpload;
